import { Modal } from 'antd'

const MIME_EXTENSION_MAP = {
  'application/msword': '.doc',
  'application/pdf': '.pdf',
  'application/rtf': '.rtf',
  'application/vnd.ms-excel': '.xls',
  'application/vnd.ms-powerpoint': '.ppt',
  'application/vnd.oasis.opendocument.graphics': '.odg',
  'application/vnd.oasis.opendocument.presentation': '.odp',
  'application/vnd.oasis.opendocument.spreadsheet': '.ods',
  'application/vnd.oasis.opendocument.text': '.odt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    '.pptx',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    '.docx',
  'application/xml': '.xml',
  'text/csv': '.csv',
  'text/html': '.html',
  'text/plain': '.txt',
  'text/rtf': '.rtf',
  'text/xml': '.xml'
}

const MEDIA_EXTENSION_MAP = {
  PDF: '.pdf',
  TEXT: '.txt'
}

const getExtensionFromMimeType = mimeType => {
  const normalizedMimeType = (mimeType || '').toLowerCase()

  if (MIME_EXTENSION_MAP[normalizedMimeType]) {
    return MIME_EXTENSION_MAP[normalizedMimeType]
  }

  if (normalizedMimeType.startsWith('application/vnd.oasis.opendocument.')) {
    return `.${normalizedMimeType.split('.').pop()}`
  }

  return ''
}

const getExtensionForItem = item => {
  const mimeExtension = getExtensionFromMimeType(item?.media_mime_type)
  const mediaFormat = (item?.media_format || '').toUpperCase()

  return mimeExtension || MEDIA_EXTENSION_MAP[mediaFormat] || ''
}

const getBaseFileName = item => {
  const sourceName = item?.title || item?.filename || item?.name || item?.path || ''
  const fileName = sourceName.split('/').pop().split('?')[0]
  const lastDotIndex = fileName.lastIndexOf('.')

  if (lastDotIndex <= 0) {
    return fileName || 'download'
  }

  return fileName.substring(0, lastDotIndex)
}

export const getDownloadFileName = item => {
  const extension = getExtensionForItem(item)
  const sourceName = item?.title || item?.filename || item?.name || item?.path || ''
  const fileName = sourceName.split('/').pop().split('?')[0]

  if (!extension) {
    return fileName || 'download'
  }

  if (fileName.toLowerCase().endsWith(extension)) {
    return fileName
  }

  return `${getBaseFileName(item)}${extension}`
}

const triggerAnchorDownload = (downloadUrl, item) => {
  const link = document.createElement('a')
  link.href = downloadUrl
  link.download = getDownloadFileName(item)
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const triggerFileDownload = async (downloadUrl, item) => {
  try {
    const response = await fetch(downloadUrl)

    if (!response.ok) {
      throw new Error(`Download failed with status ${response.status}`)
    }

    const blob = await response.blob()
    const objectUrl = URL.createObjectURL(blob)
    triggerAnchorDownload(objectUrl, item)
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0)
  } catch (error) {
    void error
    triggerAnchorDownload(downloadUrl, item)
  }
}

export const showDownloadPreparationModal = () =>
  Modal.info({
    title: 'Preparing download',
    content: 'Please wait while your file is prepared.',
    centered: true,
    okButtonProps: {
      style: { display: 'none' }
    },
    maskClosable: false
  })
